module.exports = __webpack_public_path__ + "static/media/twitter.5985dccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/twitter.svg
// module id = 1800
// module chunks = 0